export default {
      id: "ic_chevron_date-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic_chevron_date-usage",
      toString: function () {
        return this.url;
      }
    }